import { useState } from 'react';
import { OrganizationType } from '../../../hoc/common/types';
import TotalRiskScoring from './parts/total-risk-scoring';
import { AMLRiskScoringTypes } from './types';
import { PermissionEnum } from '../../../../../baseella-ui-components/src';
import IndividualRiskScoring from './parts/individual-risk-scoring';
import CorporateRiskScoring from './parts/corporate-risk-scoring';

import cn from './styles.module.css';

const RiskScoring = ({
  aml,
  onUpdate,
  updateInProgress,
  updateIsSuccess,
  amlUpdateStatus,
  calculateAllowed,
  status,
  isLoading,
  users,
  manualScoreAllowed,
  setRiskScoreChangeLogsSidepanelVisible,
  setManualScoreSidepanelVisible,
  monthlyTurnover,
  countries,
  activePermissions,
  type,
  clientsActivities,
  individualDeliveryChannels,
  individualProducts,
  sourcesOfFunds,
  corporateDeliveryChannels,
  corporateProducts,
  sicCodesDictionaries,
  riskScoreRanges,
}: AMLRiskScoringTypes & { type: OrganizationType }) => {
  const [blockCollapsed, setBlockCollapsed] = useState(false);

  let content;

  if (type === OrganizationType.INDIVIDUAL) {
    content = (
      <IndividualRiskScoring
        aml={aml}
        monthlyTurnover={monthlyTurnover}
        countries={countries}
        blockCollapsed={blockCollapsed}
        clientsActivities={clientsActivities}
        deliveryChannels={individualDeliveryChannels}
        products={individualProducts}
        sourcesOfFunds={sourcesOfFunds}
        riskScoreRanges={riskScoreRanges}
      />
    );
  } else {
    content = (
      <CorporateRiskScoring
        aml={aml}
        monthlyTurnover={monthlyTurnover}
        countries={countries}
        blockCollapsed={blockCollapsed}
        deliveryChannels={corporateDeliveryChannels}
        products={corporateProducts}
        sourcesOfFunds={sourcesOfFunds}
        sicCodesDictionaries={sicCodesDictionaries}
        riskScoreRanges={riskScoreRanges}
      />
    );
  }

  return (
    <div className={cn.riskScoringContent}>
      <TotalRiskScoring
        aml={aml}
        // logs={aml?.totalRisk.totalRiskScoreLogs}
        updateIsSuccess={updateIsSuccess}
        updateInProgress={updateInProgress}
        onUpdate={onUpdate}
        onCollapse={() => setBlockCollapsed(!blockCollapsed)}
        blockCollapsed={blockCollapsed}
        amlUpdateStatus={amlUpdateStatus}
        calculateAllowed={calculateAllowed}
        status={status}
        isLoading={isLoading}
        users={users}
        manualScoreAllowed={manualScoreAllowed}
        riskScoreRanges={riskScoreRanges}
        setManualScoreSidepanelVisible={
          setManualScoreSidepanelVisible as (data: boolean) => void
        }
        changeLogsAvailable={
          type === OrganizationType.INDIVIDUAL
            ? activePermissions?.includes(
                PermissionEnum.INDIVIDUAL_CUSTOMERS_SCORE_LIST,
              )
            : activePermissions?.includes(
                PermissionEnum.CORPORATE_CUSTOMERS_SCORE_LIST,
              )
        }
        setRiskScoreChangeLogsSidepanelVisible={
          setRiskScoreChangeLogsSidepanelVisible as (data: boolean) => void
        }
      />
      {content}
    </div>
  );
};

export default RiskScoring;
